import React from 'react';
import { ASSETS } from '../../assetManifest.js';
import { filterShopDragons, getRarityColor, getElementColor, getElementGlow } from '../../utils/gameUtils.js';
import { getAssetKey } from '../../utils/assetUtils.js';

const ShopTab = ({ 
  unlockedDragons, 
  shopCosts, 
  coins, 
  playerDragons, 
  maxDragons, 
  onBuyDragon 
}) => {
  const shopDragons = filterShopDragons(unlockedDragons);

  return (
    <div className="card-enhanced h-full flex flex-col">
      <div className="flex items-center space-x-3 mb-4 flex-shrink-0">
        <h2 className="text-2xl font-mono font-semibold text-green-400 text-glow">Marketplace</h2>
      </div>
      <div className="flex-1 overflow-y-auto custom-scrollbar pr-2 -mr-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {shopDragons.map(dragon => (
            <div key={dragon.name} className="bg-gray-900/50 p-4 rounded-lg transition-all duration-300 border border-transparent hover:border-white/20 hover:bg-gray-900/80 relative overflow-hidden"
                style={{ '--element-color': getElementColor(dragon.element) }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-[var(--element-color)] opacity-50"></div>
              <div className="flex flex-col items-center text-center h-full">
                <div className="relative mb-3">
                  <img
                    src={ASSETS.dragons[getAssetKey(dragon.name)].path}
                    alt={dragon.name}
                    className="w-16 h-16 transition-transform duration-300 hover:scale-110"
                    style={{ filter: `drop-shadow(0 0 8px ${getElementGlow(dragon.element)})` }}
                  />
                  <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-black"
                      style={{ backgroundColor: getRarityColor(dragon.rarity) }}>
                    1
                  </div>
                </div>
                <div className="flex-grow">
                  <p className="text-sm font-mono font-bold mb-1">{dragon.name}</p>
                  <p className="text-xs font-sans mb-2" style={{ color: getRarityColor(dragon.rarity) }}>
                    {dragon.rarity}
                  </p>
                  <p className="text-xs text-green-400 mb-3 font-sans">+{dragon.coinsPerSecond}/sec</p>
                </div>
                
                <div className="w-full mt-auto">
                  <button
                    onClick={() => onBuyDragon(dragon.name)}
                    disabled={coins < shopCosts[dragon.name] || playerDragons.length >= maxDragons}
                    className="btn btn-primary text-xs px-3 py-2 w-full"
                  >
                    Buy for {shopCosts[dragon.name].toLocaleString()}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopTab;
